import { render, staticRenderFns } from "./AnimateElement.vue?vue&type=template&id=52b8e34a&scoped=true&"
import script from "./AnimateElement.vue?vue&type=script&lang=js&"
export * from "./AnimateElement.vue?vue&type=script&lang=js&"
import style0 from "./AnimateElement.vue?vue&type=style&index=0&id=52b8e34a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b8e34a",
  null
  
)

export default component.exports